import { render, staticRenderFns } from "./ReviewItem.vue?vue&type=template&id=788368fa&scoped=true&"
import script from "./ReviewItem.vue?vue&type=script&lang=js&"
export * from "./ReviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788368fa",
  null
  
)

export default component.exports